import { isBelowBreakpoint } from '@/shared/helpers/responsiveness'

import { useCallback } from 'react'

import { useSideMenuContext } from './context'

/**
 * Returns a click handler that closes the drawer when running on a mobile
 * viewport (`<lg`). On desktop, the pinned state is preserved.
 */
export const useCloseOnMobile = (): (() => void) => {
  const { setOpen } = useSideMenuContext()
  return useCallback(() => {
    if (isBelowBreakpoint('lg')) {
      setOpen(false)
    }
  }, [setOpen])
}
